// extracted by mini-css-extract-plugin
export default {"backButton":"sC_sE","backButton_visible":"sC_sF"};